import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { baseURL } from "../../../basics";
import ShowPriceInCardItem from "./ShowPriceInCardItem";
import LikeAndUnLikeButton from "../../Ui/LikeAndUnLikeButton";
import UnitTypeBox from "../../Ui/UnitTypeBox";
import GradeDescription from "../../Ui/GradeDescription";
import CheckStockAndChangeButton from "../../Ui/CheckStockAndChangeButton";
import { useSelector } from "react-redux";

const ProductItem = (props: any) => {
  const { id, title, price, imageUrl, discountedPrice, unit, unitType, grade } =
    props.items;

  const history = useHistory();
  const sendUserToProductItemPage = () => {
    history.push(`/products/productItem/${id}`);
  };
  const [truncatedText, settRuncatedText] = useState("");
  useEffect(() => {
    if (title) {
      const rangeStart = 0;
      const rangeEnd = 20;
      const lastWordBoundary = title.lastIndexOf(" ", rangeEnd);
      const truncatedText =
        lastWordBoundary >= rangeEnd
          ? `${title.substring(rangeStart, lastWordBoundary)} ...`
          : `${title.substring(rangeStart, rangeEnd)}`;
      settRuncatedText(truncatedText);
    }
  }, [title]);
  const prductItemCodeColor = useSelector(
    (state: any) => state.shopInfo.shopInfoData.prductItemCodeColor
  );
  return (
    <div className="relative ">
      <form
        className={`group max-w-xs w-full min-h-[280px] sm:w-[230px] sm:h-[330px] sm:min-h-0 overflow-hidden bg-[${prductItemCodeColor}] bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col justify-between m-2 relative`}
        style={{ background: props.colorCode }}
      >
        <LikeAndUnLikeButton item={props.items} />

        <div
          onClick={sendUserToProductItemPage}
          className="grid justify-items-stretch cursor-pointer"
        >
          <div className="flex justify-center items-center pt-4">
            <img
              src={`${baseURL}${imageUrl}`}
              alt={title}
              className="h-24 w-24 object-contain rounded-full m-2 bg-white/80 p-2 ring-1 ring-black/5 group-hover:scale-105 transition-transform duration-200"
            />
          </div>

          <div className="text-base px-3 pb-4 flex flex-col justify-between">
            <div>
              <p className="text-base py-2 min-h-[52px] font-bold text-gray-900 flex justify-center items-center text-center leading-7">
                {truncatedText}
              </p>

              <GradeDescription grade={grade} color={"black"} />
              <div className="pt-3 flex flex-col items-center gap-1.5">
                <UnitTypeBox unit={unit} unitType={unitType} />
                <ShowPriceInCardItem
                  price={price}
                  discountedPrice={discountedPrice}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center p-3 pt-0">
          <CheckStockAndChangeButton
            parentStyles={""}
            childStyles={"bg-emerald-500 hover:bg-emerald-600 shadow-sm"}
            items={props.items}
            variant="circle"
          />
        </div>
      </form>
    </div>
  );
};
export default ProductItem;
